import { ButtonVariant } from "app/storybookComponents/Button/types";
import Button from "app/storybookComponents/Button";
import { OverlayTrigger, Popover } from "react-bootstrap";

interface Props {
  sendButtonText?: string;
  sentButtonText?: string;
  onClick?: () => void;
  disabled?: boolean;
  reminderSent?: boolean;
  tooltipMessage?: string;
  variant?: ButtonVariant;
  className?: string;
  prefixContent?: React.ReactNode;
}

const ReminderButton = ({
  sendButtonText = "Send Reminder",
  sentButtonText = "Reminder Sent",
  onClick,
  disabled,
  reminderSent,
  tooltipMessage = "Reminders can only sent every 5 minutes. Please try again later.",
  variant,
  className,
  prefixContent = null,
}: Readonly<Props>) => {
  if (!reminderSent) {
    return (
      <Button
        variant={variant}
        disabled={disabled}
        onClick={onClick}
        className={className}
      >
        {prefixContent}
        {sendButtonText}
      </Button>
    );
  }

  const overlay = (
    <Popover className="team-360-popover">
      <div>
        <p>{tooltipMessage}</p>
      </div>
    </Popover>
  );

  return (
    <OverlayTrigger
      rootClose
      placement="auto"
      overlay={overlay}
      trigger={["hover", "focus"]}
    >
      <span>
        <Button variant={variant} className={className} disabled>
          {prefixContent}
          {sentButtonText}
        </Button>
      </span>
    </OverlayTrigger>
  );
};

export default ReminderButton;
